var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVolts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    id: "svg6485",
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6487"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0,-1028.3622)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g4996",
    transform: "translate(36,0)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 12 0 C 5.3785053 0 0 5.3785 0 12 C 0 18.6215 5.3785053 24 12 24 C 18.621495 24 24 18.6215 24 12 C 24 5.3785 18.621495 0 12 0 z M 12 1 C 18.081055 1 23 5.919 23 12 C 23 18.0811 18.081055 23 12 23 C 5.9189454 23 1 18.0811 1 12 C 1 5.919 5.9189454 1 12 1 z M 7 5 L 7 19 L 17 19 L 17 5 L 7 5 z M 8 6 L 16 6 L 16 12 L 8 12 L 8 6 z M 12 14 A 2 2 0 0 1 13.425781 14.599609 L 10.072266 16.535156 A 2 2 0 0 1 10 16 A 2 2 0 0 1 12 14 z M 13.927734 15.464844 A 2 2 0 0 1 14 16 A 2 2 0 0 1 12 18 A 2 2 0 0 1 10.574219 17.400391 L 13.927734 15.464844 z ",
    id: "rect4950",
    style: {
      color: "#000000",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000000",
      solidOpacity: 1,
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto",
      enableBackground: "accumulate"
    },
    transform: "translate(0,1028.3622)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolts);
export default __webpack_public_path__ + "static/media/volts.0997d060.svg";
export { ForwardRef as ReactComponent };